import styled from "styled-components";
import config from "../../../Config/config.json";
import Theme from "../../../Styles/Themes/index.js";
import { GetColors } from "../../../util/Colors.js";
import SVG from "react-inlinesvg";

export const Container = styled.main`
    display: flex;
    flex-direction: column;
    margin-top: 75px;
    padding: 30px;
    width: -webkit-fill-available;
    @media (min-width: 720px) {
        margin: 20px 0 0 176px;
    }

    .header{
        align-items: flex-start;
        display: flex;
        justify-content: space-between;
        width: 100%;
    }
`;

export const HeaderContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    padding: 10px 20px;
    gap: 10px;

    @media (min-width: 720px) {
        display: flex;
        flex-direction: row;
        justify-content: ${({ $top }) => $top ? 'space-between' : 'space-around'};
        padding: 10px 0;
        width: 100%;
    }

    @media (min-width: 768px) and (max-width: 1024px) {
        align-items: center;
        flex-direction: column;
        justify-content: center;
    }

    .selects {
        display: flex;
        flex-direction: column;
        gap: 20px;

        @media (min-width: 720px) {
            flex-direction: row;
        }
    }

    .buttons-container {
        align-items: center;
        display: flex;
        gap: 10px;
        justify-content: space-around;
        
        @media (min-width: 720px) {
            flex-direction: row;
            width: 50%;
        }
    }
`;

export const BodyContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 25px;
`;

export const ContainerTable = styled.div`
    display: flex;
    flex-direction: column;
    overflow: auto;
    width: 100%;
`

export const Table = styled.table`
    border: 0px; 
    border-collapse: separate;
    border-spacing: 0px 10px;
    width: 100%;
`;

export const TableHeader = styled.th`
    border: 0px; 
    color: #333;
    font-weight: 900;
    padding: 8px;
    text-align: center;
`;

export const TableRow = styled.tr`
    border: 0px; 
`;

export const TableCell = styled.td`
    border: 1px solid #ddd;
    border: 0px; 
    padding: 8px;
`;

export const TableCellItem = styled.span`
    align-items: center;
    background: ${({ $alarm }) => {return (
        $alarm === 0 ? '#BBEBD5' :
        $alarm === 1 ? '#F8FFCC' : 
        $alarm === 2 ? '#FFCCD5' :
        '#fff')
    }};
    border: 1px solid black;
    border-radius: 5px;
    color: black;
    display: flex;
    height: 100%;
    justify-content: center;
    margin: 0 0 0 10px;
    padding: 0 0;
    padding-inline: 5px;
    text-align: center;
    white-space: nowrap;
`;

export const GraphContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-block: 15px;
    width: 100%;
`;

export const ContainerSpinner = styled.div`
    align-items: center;
    display: flex;
    justify-content: center;
`;

export const NoData = styled.span`
    color: #333;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
`;

export const DownloadiconContainer = styled(SVG)`
    align-self: center;
    height: 30px;
    width: 30px;
    & path {
        fill: #006560;
    }
`;

export const ButtonDownload = styled.button`
    align-items: center;
    align-self: center;
    background: ${props=> props.$color ? GetColors(props.$color).background : Theme[config.theme].colors.buttonBackground};
    border: ${props=> props.$color ? GetColors(props.$color).border : 'none'};
    border-radius: 10px;
    color: ${props=> props.$color ? GetColors(props.$color).color : Theme[config.theme].colors.secondaryFontColor};
    cursor: pointer;
    display: flex;
    font-size: ${Theme[config.theme].font.labels[config.fontSize].size};
    font-weight: ${Theme[config.theme].font.labels[config.fontSize].weight};
    gap: 10px;
    height: fit-content;
    justify-content: center;
    line-height: ${Theme[config.theme].font.labels[config.fontSize].line_height};
    padding: 20px 20px 20px 20px;
    width: ${props => props.$width};
    &:hover {
        background: ${props=> props.$color ? GetColors(props.$color).hoverbg : Theme[config.theme].colors.buttonBackgroundHover};
        color: ${props=> props.$color ? GetColors(props.$color).hovercolor : Theme[config.theme].colors.secondaryFontColor};
    }
    &:focus {
        ${props=> props.$color ? GetColors(props.$color).background :  'background:' + Theme[config.theme].colors.buttonBackgroundFocus};
    }
    &:disabled{
        background: #A3A3A3;
    }
    &:hover .icon path {
        fill: ${props => props.$color && GetColors(props.$color).hovercolor};
    }

`;

export const GraphTitle = styled.span`
    color: #333;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
`;

export const ContainerCheckbox = styled.form`
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 20px;
    width: 100%;
`;

export const LegendContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 15px;
    justify-content: center;
    margin-block: 10px;
`;